
<script>

</script>
<template>
    <div class="goods">
      <Scroll :height="scrollHeight">
        <van-nav-bar :title="formValidate.workflow_type" left-text="返回" right-text="重置" left-arrow @click-left="getRouteQuery()" @click-right="handleReset" />

        <van-form @submit="handleSubmit" ref="asset" style="overflow-y: auto;" >

        <van-divider />
            <van-field v-model="formValidate.name" name="姓名" label="姓名" placeholder="请输入姓名" :readonly="readonly" :rules="[{ required: true, message: '请填姓名' }]" size="large" @blur="checkUser"></van-field>

            <van-field readonly clickable name="邮箱" :value="formValidate.mail" label="邮箱" placeholder="点击选择邮箱" :rules="[{ required: true, message: '请选择邮箱' }]" @click="readonly?'':showUserPicker = true" size="large"/>
            <van-notice-bar scrollable text="如有姓名类似或者同名, 请选择对应的邮箱" />

            <van-field v-model="formValidate.department" name="部门" label="部门" placeholder="检索部门" readonly size="large" type="textarea" rows="1"/>

            <van-field v-model="formValidate.created_at" name="时间" label="时间" placeholder="时间" readonly size="large"/>

            <van-field v-if="formValidate.workflow_type === '转让'" v-model="formValidate.transfer_name" name="转让人" label="转让人" placeholder="请输入转让人" :readonly="readonly" :rules="[{ required: true, message: '请填转让人' }]" size="large" @blur="checkTransferUser"></van-field>

            <van-field v-if="formValidate.workflow_type === '转让'" readonly clickable name="转让邮箱" :value="formValidate.transfer_mail" label="转让邮箱" placeholder="点击选择转让邮箱" :rules="[{ required: true, message: '请选择转让邮箱' }]" @click="readonly?'':showTransferPicker = true" size="large"/>

            <van-field v-show="formValidate.workflow_type === '领用' || readonly" v-model="formValidate.sn_list[index]" center label="资产编码" placeholder="请输入资产编码" v-for="(_, index) in formValidate.sn_list" :key="index" :readonly="formValidate.sn_list_disable[index]" size="large">
              <template #button>
                <van-icon v-if="!formValidate.sn_list_disable[index]" @click="setDisable" name="checked" size="large" />
                <van-icon  @click="remove(index)" style="margin-left: 10px;" name="clear" size="large"/>
              </template>
            </van-field>

            <van-checkbox-group v-if=" formValidate.workflow_type !== '领用' && formValidate.sn_list.length !== 0 && formValidate.sn_list[0] && !readonly" v-model="sn_list_result">
              <van-divider dashed :margin="12">已有资产编码</van-divider>
              <van-cell-group>
                <van-cell
                  v-for="(item, index) in formValidate.sn_list"
                  clickable
                  :key="item"
                  :title="`${item}`"
                  @click="toggle(index)"
                >
                  <template #right-icon>
                    <van-checkbox :name="item" ref="checkboxes" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>

            <van-divider v-show="formValidate.workflow_type === '更换'" dashed :margin="12">新资产编码</van-divider>
            <van-field v-show="formValidate.workflow_type === '更换'" v-model="formValidate.new_sn_list[index]" center label="资产编码" placeholder="请输入资产编码" v-for="(_, index) in formValidate.new_sn_list" :key="index" :readonly="formValidate.new_sn_list_disable[index]" size="large">
              <template #button>
                <van-icon v-if="!formValidate.new_sn_list_disable[index]" @click="setDisable" name="checked" size="large" />
                <van-icon  @click="remove(index)" style="margin-left: 10px;" name="clear" size="large"/>
              </template>
            </van-field>

            <van-field v-show="formValidate.workflow_type === '更换'" v-model="formValidate.replace_reason" name="更换原因" label="更换原因" placeholder="请输入更换原因" :readonly="readonly" size="large"></van-field>

            <van-button v-if="!readonly" icon="plus" round block type="default" @click="add()" size="small" color="#7232dd" plain></van-button>

            <div style="margin: 16px;">
                <van-button v-if="status === 'add' && !readonly" round block type="info" native-type="submit" size="large" color="#7232dd">提交</van-button>
                <van-button v-if="status === 'update'" round block type="info" native-type="submit" size="large" color="#7232dd">修改</van-button>
            </div>

            <van-divider dashed :margin="12">审批状态</van-divider>

            <van-steps v-if="formValidate.approval" :active="active" active-icon="info" active-color="#7232dd">
              <van-step> {{formValidate.name}} <tag color="#7232dd">已提交</tag> </van-step>
              <van-step v-if="formValidate.transfer_status"> {{formValidate.transfer_name}} <van-tag :type="formValidate.transfer_status === '审批中' ? 'warning' : formValidate.transfer_status === '驳回' ? 'danger' : 'primary'">{{ formValidate.transfer_status }}</van-tag> </van-step>
              <van-step>  {{ formValidate.operator_info ? `${formValidate.operator_info.name}` : formValidate.operator ? formValidate.operator : '固资管理员' }}<van-tag :type="formValidate.approval === '审批中' ? 'warning' : formValidate.approval === '驳回' ? 'danger' : 'primary'">{{ formValidate.approval }}</van-tag>  </van-step>
            </van-steps>
        </van-form>

        <div id="app">
          <van-popup v-model="showUserPicker" get-container="#app" position="bottom" :lock-scroll="false">
            <van-picker
              show-toolbar
              :columns="emailList"
              @confirm="onEmailConfirm"
              @cancel="showUserPicker = false"
            />
        </van-popup>

        <van-popup v-model="showTransferPicker" get-container="#app" position="bottom" :lock-scroll="false">
          <van-picker
            show-toolbar
            :columns="transferEmailList"
            @confirm="onTransferEmailConfirm"
            @cancel="showTransferPicker = false"
          />
        </van-popup>

        </div>
      </Scroll>

      <van-dialog v-model="showWorkflowType" title="选择工单类型" :showConfirmButton="false" >
        <van-cell is-link @click="onClickWorkflowType('领用', '领用')">领用</van-cell>
        <van-cell is-link @click="onClickWorkflowType('归还', '归还')">归还</van-cell>
        <van-cell is-link @click="onClickWorkflowType('转让', '转让')">转让</van-cell>
        <van-cell is-link @click="onClickWorkflowType('更换', '更换')">更换</van-cell>
        <van-cell is-link @click="onClickWorkflowType('临时领用', '临时领用')">临时领用</van-cell>
        <!-- <van-tabs :active="formValidate.workflow_type" color="#7232dd" type="card" @click="onClickWorkflowType" style="margin-top: 10px;">
          <van-tab title="领用" name="领用"></van-tab>
          <van-tab title="归还" name="归还"></van-tab>
          <van-tab title="转让" name="转让"></van-tab>
          <van-tab title="更换" name="更换"></van-tab>
        </van-tabs> -->
      </van-dialog>

    </div>
</template>
<script>
import { Button, Form, Field, NavBar, Popup, Picker, Checkbox, Icon, Toast, Divider, Notify, Steps, Step, Tag, List, Cell, CheckboxGroup, Tab, Tabs, Dialog, NoticeBar } from 'vant'
import { authByName } from '@/api/user'
import { getAssetDataByWorkflow, getAssetDataByName, addAssetWorkflow, getAssetWorkflow } from '@/api/cmdb'
import moment from 'moment'
import 'vant/lib/index.css';
export default {
  components: { [Button.name]: Button,  [Form.name]: Form,  [Field.name]: Field, [NavBar.name]: NavBar, [Popup.name]: Popup,  [Picker.name]: Picker,  [Checkbox.name]: Checkbox,  [Icon.name]: Icon, [Divider.name]: Divider,
                  [Steps.name]: Steps, [Step.name]: Step, [Tag.name]: Tag , [List.name]: List, [Cell.name]: Cell, [CheckboxGroup.name]: CheckboxGroup, [Tab.name]: Tab, [Tabs.name]: Tabs, [Dialog.Component.name]: Dialog.Component, [NoticeBar.name]: NoticeBar, },
  data () {
    return {
      formValidate: {
        name: null,
        mail: null,
        userid: null,
        transfer_name: null,
        transfer_mail: null,
        transfer_userid: null,
        workflow_type: '领用',
        department: null,
        created_at: '',
        sn_list: [''],
        sn_list_disable: [false],
        new_sn_list: [''],
        new_sn_list_disable: [false],
        remark: null,
        replace_reason:null,
        operator_info: null,
        sn_list_by_total: []
      },
      readonly: false,
      showUserPicker: false,
      showTransferPicker: false,
      emailList: [],
      emailDict: {},
      transferEmailList: [],
      transferEmailDict: {},
      active: 1,
      status: 'add',
      scrollHeight: 0,
      sn_list_result: [],
      showWorkflowType: true
    }
  },

  mounted () {
    setTimeout(()=>{
      this.getRouteQuery()
    }, 500)
    this.scrollHeight = window.innerHeight
  },
  methods: {
    toggle(index) {
      this.$refs.checkboxes[index].toggle()
    },
    getRouteQuery(reset){
      const { workflow_type, id, readonly, sn_list } = this.$route.query
      if (workflow_type){
        this.formValidate.workflow_type = workflow_type
        this.formValidate.id = id
      }
      console.log({ workflow_type, id, readonly, sn_list })
      if(id && !reset){
        this.showWorkflowType = false
        getAssetWorkflow({id: id, sn_list: sn_list.replaceAll('\\', '')}).then(rsp=>{
          const { data } = rsp.data
          if (!data.id){
            return
          }
          this.formValidate.id = data.id
          Object.keys(this.formValidate).forEach(key=>{
            if (data[key]){
              this.formValidate[key] = data[key]
            }
            this.formValidate.sn_list_disable = []
            this.formValidate.sn_list.forEach(_s=>{
              if (readonly === 'update' && (data.approval === '审批中' || data.transfer_status === '审批中')){
                this.status = 'update'
                this.formValidate.operator_id = this.$store.state.user.userId,
                this.formValidate.sn_list_disable.push(false)
              }else{
                this.formValidate.sn_list_disable.push(true)
              }

            })
          })
          if(data.approval){
            this.formValidate.approval = data.approval
            this.active = 1
          }
          if(data.transfer_status){
            this.formValidate.transfer_status = data.transfer_status
            if(data.transfer_status !== '审批中'){
              this.active = 2
            }
          }
          if (data.sn_list.length === 0){
            this.getSnList(data.workflow_type)
          }
          this.readonly = true
        })
      }
    },

    getSnList(workflow_type){
      if(workflow_type !== '领用'){
        getAssetDataByName({name: this.formValidate.name}).then(rsp=>{
          const { data } = rsp.data
          console.log(data)
          this.formValidate.sn_list = []
          this.formValidate.sn_list_disable = []
          data.forEach(_sn=>{
            this.formValidate.sn_list.push(_sn.asset_id)
            this.formValidate.sn_list_disable.push(false)
          })
        })
      }
    },

    handleReset () {
      this.formValidate = {
        name: null,
        mail: null,
        userid: null,
        transfer_name: null,
        transfer_mail: null,
        transfer_userid: null,
        workflow_type: '领用',
        department: null,
        created_at: null,
        sn_list: [''],
        sn_list_disable: [false],
        new_sn_list: [''],
        new_sn_list_disable: [false],
        remark: null,
        sn_list_by_total: []
      }
      this.getRouteQuery(true)
      this.readonly = false
    },

    onEmailConfirm (value) {
      this.formValidate.mail = value
      if(this.emailDict[value]){
        this.formValidate.name = this.emailDict[value].name
        this.formValidate.mail = value
        this.formValidate.userid = this.emailDict[value].userid
        this.formValidate.department = this.emailDict[value].unitFullName
        this.getSnList(this.formValidate.workflow_type)
      }
      this.showUserPicker = false
    },

    onTransferEmailConfirm (value) {
      this.formValidate.transfer_mail = value
      if(this.transferEmailDict[value]){
        this.formValidate.transfer_name = this.transferEmailDict[value].name
        this.formValidate.transfer_mail = value
        this.formValidate.transfer_userid = this.transferEmailDict[value].userid
      }
      this.showTransferPicker = false
    },

    remove (index) {
      console.log(index, !this.readonly && this.status !== 'update')
      if(!this.readonly || this.status === 'update'){
        this.formValidate.sn_list.splice(index, 1)
        this.formValidate.sn_list_disable.splice(index, 1)
      }
    },

    setDisable () {
      if (this.formValidate.workflow_type === '更换'){
        for(let i=0; i < this.formValidate.new_sn_list.length; i++){
          getAssetDataByWorkflow({asset_id : this.formValidate.new_sn_list[i], workflow_type: this.formValidate.workflow_type}).then(rsp=>{
            const {data, code, msg} = rsp.data
             if (data.asset_id){
              if(data.status !== 1){
                Notify({ type: 'danger', message: '设备信息不是在库状态, 请让资产管理员检查相关信息', duration: 5000 })
                return
              }
              this.formValidate.new_sn_list_disable[i] = true
              const new_sn_list = this.formValidate.new_sn_list
              this.formValidate.new_sn_list = []
              new_sn_list.forEach(sn => {
                this.formValidate.new_sn_list.push(sn)
              })
            }else{
              Notify({ type: 'danger', message: `无资产编码【${this.formValidate.new_sn_list[i]}】的资产信息, 请检查, 重新输入` })
            }
          })
        }
      }else{
        for(let i=0; i < this.formValidate.sn_list.length; i++){
          getAssetDataByWorkflow({asset_id : this.formValidate.sn_list[i], workflow_type: this.formValidate.workflow_type}).then(rsp=>{
            const {data, code, msg} = rsp.data
            if(code === 500){
              Notify({ type: 'danger', message: msg, duration: 5000 })
            }else if (data.asset_id){
              this.formValidate.sn_list_disable[i] = true
              const sn_list = this.formValidate.sn_list
              this.formValidate.sn_list = []
              sn_list.forEach(sn => {
                this.formValidate.sn_list.push(sn)
              })
            }else{
              Notify({ type: 'danger', message: `无资产编码【${this.formValidate.sn_list[i]}】的资产信息, 请检查, 重新输入` })
            }
          })
        }
      }

    },

    add () {
      if(this.formValidate.workflow_type !== '更改'){
        this.formValidate.sn_list.push('')
        this.formValidate.sn_list_disable.push(false)
      }else{
        this.formValidate.new_sn_list.push('')
        this.formValidate.new_sn_list_disable.push(false)
      }
    },

    checkUser(){
        this.emailList = []
        if (!this.formValidate.name){
          Toast.loading({ message: '输入姓名不能为空', forbidClick: true})
          return
        }else{
          Toast.loading({ message: '正在检索用户信息...', forbidClick: true, duration: 120000})
        }
        authByName( {name : this.formValidate.name} ).then(rsp=>{
            Toast.clear()
            if(Object.keys(rsp.data).length === 0){
                Toast.fail("未找到用户信息, 请重新输入")
            }else{
                const { data } = rsp.data
                data.forEach(_user=>{
                  this.emailList.push(_user.email)
                  this.emailDict[_user.email] = _user
                })
                this.formValidate.mail = null
                this.formValidate.userid = null
                this.formValidate.department = null
                this.formValidate.created_at = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                this.showUserPicker = true
                if(Object.keys(rsp.data).length === 1){
                  this.formValidate.name = data[0].name
                  this.formValidate.mail = data[0].email
                  this.formValidate.userid = data[0].userid
                  this.formValidate.department = data[0].unitFullName
                  this.getSnList(this.formValidate.workflow_type)
                  this.showUserPicker = false
                }
            }
        }).catch(_=>{
            Toast.clear()
        })
    },

    checkTransferUser(){
        this.transferEmailList = []
        Toast.loading({ message: '正在检索用户信息...', forbidClick: true, duration: 120000 })
        authByName( {name : this.formValidate.transfer_name} ).then(rsp=>{
            Toast.clear()
            if(Object.keys(rsp.data).length === 0){
                Toast.fail("未找到用户信息, 请重新输入")
            }else{
                const { data } = rsp.data
                data.forEach(_user=>{
                  this.transferEmailList.push(_user.email)
                  this.transferEmailDict[_user.email] = _user
                })
                this.formValidate.transfer_mail = null
                this.formValidate.transfer_userid = null
                this.showTransferPicker = true
                if(Object.keys(rsp.data).length === 1){
                  this.formValidate.transfer_name = data[0].name
                  this.formValidate.transfer_mail = data[0].email
                  this.formValidate.transfer_userid = data[0].userid
                  this.showTransferPicker = false
                }
            }
        }).catch(_=>{
            Toast.clear()
        })
    },

    onClickWorkflowType(name, title){
      this.formValidate.workflow_type = name
      if(name !== '领用'){
        // this.$router.push(`/frhome/cmdb/workflow/detail?workflow_type=${name}`)
        window.location.href= window.location.origin + `/frhome/cmdb/workflow/detail/${name}`
      }else{
        this.$router.replace({ query: {workflow_type: name} })
      }
      this.showWorkflowType = false

    },

    handleSubmit () {

      // 全局表单验证
      this.$refs.asset.validate().then(() => {
        if(this.formValidate.sn_list.length === 0){
          Notify({ type: 'danger', message: `请填写资产编号` })
          return
        }
        this.setDisable()
        setTimeout(()=>{
          if(this.formValidate.workflow_type === '领用'){
            if(this.formValidate.sn_list_disable.indexOf(false) !== -1){
              Notify({ type: 'danger', message: `请检查资产编号是否填写正确` })
              return
            }
          }else if (this.formValidate.workflow_type === '更换'){
            if(this.formValidate.new_sn_list_disable.indexOf(false) !== -1){
              Notify({ type: 'danger', message: `请检查资产编号是否填写正确` })
              return
            }
          }
          if(this.formValidate.workflow_type !== '领用' && this.sn_list_result.length === 0){
            Notify({ type: 'danger', message: `请选择已有资产编码` })
            return
          }
          Toast.loading({ message: '提交中...', forbidClick: true, duration: 10000 })
          const formValidate =  {...this.formValidate}
          if (this.sn_list_result.length !== 0){
            formValidate['sn_list_by_total'] = formValidate['sn_list']
            formValidate['sn_list'] = this.sn_list_result
          }
          addAssetWorkflow(formValidate).then(rsp=>{
            Toast.clear()
            const {code, msg, data} = rsp.data
            if (code === 200){
              Toast.success({ message: msg, forbidClick: true })
            }else{
              Notify({ type: 'danger', message: msg })
              this.status = 'add'
            }
            this.$router.push( {query: { id: data.id, sn_list: JSON.stringify(data.sn_list) }})
            this.readonly = true
            setTimeout(()=>{
              this.getRouteQuery()
            }, 800)
          }).catch(err=>{
            Notify({ type: 'danger', message: err })
          })
        }, 800)

      })
    },
  },

}

</script>

<style scoped>
::v-deep.van-field__control::-webkit-input-placeholder {
    font-size: 100px;
}
</style>

</script>
<style lang="less">
.goods {
  padding-bottom: 50px;

  &-swipe {
    img {
      width: 100%;
      display: block;
    }
  }

  &-title {
    font-size: 16px;
  }

  &-price {
    color: #f44;
  }

  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }

  &-cell-group {
    margin: 15px 0;

    .van-cell__value {
      color: #999;
    }
  }

  &-tag {
    margin-left: 5px;
  }
}
</style>
